import React, { useRef, useState, useEffect, useCallback } from "react";
import axios from "axios";
import Header from "./header/header";
import Footer from "./Footer";
import "./profilepage.css";
import { Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ClipLoader } from "react-spinners";
import { BsEmojiFrown } from "react-icons/bs";
import { baseUrl, GetToken, PopulateContext } from "../App";
import { useUsers } from "./Contexts/UsersContext";
import { useEnrollee } from "./Contexts/EnrolleeContext";
import { useCourses } from "./Contexts/CoursesContext";
import {
  ICertificate,
  IUserDetails,
  ICourseRegistration,
  Referrers,
} from "./EnrollTypes";
import { useDisclosure } from "./useDisclosure";
import ReferralPage from "./referralPage";

const Profilepage: React.FC = () => {
  const { Enrollee, setEnrolleeContext } = useEnrollee();
  const { User, setUserContext, setUsersContext } = useUsers();
  const {courses} = useCourses()

  const [ready, setReady] = useState(false);
  const [idToken, setIdToken] = useState("");
  const [user, setUser] = useState<IUserDetails>();
  const [Referrer, setReferrer] = useState<Referrers>();
  const [EnrolledUser, setEnrolledUser] = useState([]);
  const [doyenAccess, setDoyenAccess] = useState<any[]>([]);
  const [handsOnEx, setHandsOnEx] = useState<any[]>([]);
  const [UserCertificates, setUserCertificates] = useState([]);
  const [showPayments, setShowPayments] = useState(false);
  const [showCoursesandServices, setShowCoursesandServices] = useState(true);
  const [showCertificates, setShowCertificates] = useState(false);
  const [emptyData, setEmptyData] = useState(true);
  const [noCertificates, setNoCertificates] = useState(true);
  const [isShow, invokeModal] = React.useState(false);
  const [editedPhoneNumber, setEditedPhoneNumber] = useState("");
  const [editedFirstName, setEditedFirstname] = useState("");
  const [editedLastName, setEditedLastName] = useState("");
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");
  const [ProfileImage, setProfileImage] = useState("");
  const [showProfileImage, setShowProfileImage] = useState(false);
  const fileInputRef = useRef(null);

  let navigate = useNavigate();
  let location = useLocation();
  const { isOpen: onOpen, onClose: isClose, onOpen: isOpen } = useDisclosure();

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent("");
  };

  const initModal = () => {
    return invokeModal(true);
  };

  const close = () => {
    return invokeModal(false);
  };

  const CoursesandServices = () => {
    setShowCoursesandServices(true);
    setShowPayments(false);
    setShowCertificates(false);
  };

  const Payments = () => {
    setShowCoursesandServices(false);
    setShowPayments(true);
    setShowCertificates(false);
  };

  const Certificates = () => {
    setShowCoursesandServices(false);
    setShowPayments(false);
    setShowCertificates(true);
  };

  const fetchCourseCohortValue = (courseName: string):string=>{
    if(courses){
      let course:any = courses.filter((course) => course.CourseName === courseName);
      if(course.length>0){
      let cohortValue = course[0]?.Cohort;
      return cohortValue;
    }
    }
    return "";
  }

  const priceSplitter = (number: any) =>
    number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const getCourseandUserData = useCallback(
    async (userId: string) => {
      const idToken = await GetToken();
      setIdToken(idToken);
      try {
        if (User) {
          setUser(User);
        } else {
          if (userId) {
            const value = await PopulateContext("Users");
            const _users = value.filter((each: any) => each.id === userId);
            setUser(_users[0]);
            setUsersContext(value);
            setUserContext(_users[0]);
          }
        }
        if (user) {
          if (Enrollee) {
            let value: any = Enrollee?.filter(
              (each: any) => each?.email === user?.email
            );
            if (!value) {
              setEditedFirstname(user?.firstname);
              setEditedLastName(user?.lastname);
              setEditedPhoneNumber(user?.phone);
              if (user?.ProfileImage.length > 2) {
                setProfileImage(user?.ProfileImage);
                setShowProfileImage(true);
              }
              setReady(true);
              return;
            }
            setEnrolledUser(value);
            if (value.length > 0) {
              setEmptyData(false);
            }
            setReady(true);
          } else {
            const value = await PopulateContext("Enrollees");
            const _enrollees: any = value?.filter(
              (each: any) => each?.email === user?.email
            );
            setEnrolleeContext(value);
            setEnrolledUser(_enrollees);
            setEditedFirstname(user?.firstname);
            setEditedLastName(user?.lastname);
            setEditedPhoneNumber(user?.phone);
            if (user?.ProfileImage.length > 2) {
              setProfileImage(user?.ProfileImage);
              setShowProfileImage(true);
            }
            if (value.length > 0) {
              setEmptyData(false);
            }
            setReady(true);
          }
        }

        // FETCH DOYENACCESS
        await axios
          .get(`${baseUrl}/accessdoyen`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then((responseprofile) => {
            // console.log(responseprofile);

            var doyenAccess = responseprofile?.data;
            if (user) {
              const doyenAccessUserObject: any = [];
              for (const [userKey, userValue] of Object.entries(doyenAccess)) {
                var userData: any;
                userData = userKey;
                userData = userValue;

                if (userData?.Email === user?.email) {
                  doyenAccessUserObject.push(userData);
                }
              }
              setDoyenAccess(doyenAccessUserObject);
              if (doyenAccessUserObject.length > 0) {
                setEmptyData(false);
                // console.log("access", doyenAccessUserObject);
              }
            }
          })
          .catch((error: any) => {
            console.log(error);
          });

        // FETCH HANDSONEXPERIENCE
        axios
          .get(`${baseUrl}/handsonexp`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then((responseprofile) => {
            // console.log(responseprofile);

            var handsOn = responseprofile?.data;
            let handsList:any = []
            if (user) {
              const handsOnUserObject: any = [];
              for (const [userKey, userValue] of Object.entries(handsOn)) {
                var userData: any;
                userData = userKey;
                userData = userValue;
                if (userData?.Email === user?.email && !handsList.includes(userData?.Careerpath)) {
                  handsList.push(userData?.Careerpath)
                  handsOnUserObject.push(userData);
                }
              }
              setHandsOnEx(handsOnUserObject);
              if (handsOnUserObject.length > 0) {
                setEmptyData(false);
              }
            }
          })
          .catch((error: any) => {
            console.log(error);
          });

        //////// FETCH REFERRER ACCOUNT
        if (user) {
          const body = {
            ReferrerEmail: user?.email,
            ReferrerId: user?.ReferralId,
          };
          await axios
            .post(`${baseUrl}/referrersbyfield`, body, {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            })
            .then((referrerResponse) => {
              setReferrer(referrerResponse.data.data[0]);
            })
            .catch((error) => {
              if (
                error.response.data.code === 404 ||
                error.response.data.status === "No matching docs"
              ) {
                //console.log("You have not referred anyone yet");
              } else {
                console.log(error.response.data);
              }
            });
        }
        axios
          .get(`${baseUrl}/certificate`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then((responseprofile) => {
            var Certificates = responseprofile?.data;
            const UserCertificates: any = [];
            for (const [certificateKey, certificateValue] of Object.entries(
              Certificates
            )) {
              var certificateData: any;
              certificateData = certificateKey;
              certificateData = certificateValue;
              if (certificateData?.email === user?.email) {
                UserCertificates.push(certificateData);
              }
            }
            setUserCertificates(UserCertificates);
            if (UserCertificates.length > 0) {
              setNoCertificates(false);
            }
          });
      } catch (error: any) {
        console.log(
          "There is an error getting user details and course data: " +
            error.message
        );
        setShowModal(true);
        setModalContent(
          "Could not retrieve user details, please refresh the page."
        );
      }
    },
    [user, Enrollee, User, setEnrolleeContext, setUserContext, setUsersContext]
  );

  const resizeImage = (
    file: any,
    width: number,
    height: number,
    callback: any
  ) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");

        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);
          const resizedBase64 = canvas.toDataURL("image/jpeg");
          callback(resizedBase64);
        } else {
          console.error("Failed to get 2D context");
        }
      };
      img.src = event?.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleImageUpload = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      resizeImage(file, 100, 100, (resizedBase64: any) => {
        setProfileImage(resizedBase64);
      });
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    if (!userId) {
      navigate("/signin", { state: { from: location.pathname } });
      return;
    }
    getCourseandUserData(userId);
  }, [navigate, getCourseandUserData, location.pathname]);

  const UpdateUserProfile = async (id: string) => {
    if (
      editedFirstName.length < 2 ||
      editedLastName.length < 2 ||
      editedPhoneNumber.length < 6
    ) {
      toast("Error! Unaccepted inputs.");
    } else {
      const editedProfile = {
        ProfileImage: ProfileImage,
        firstname: editedFirstName,
        lastname: editedLastName,
        phone: editedPhoneNumber,
        Referred: user?.Referred,
      };
      // console.log(editedProfile);
      // console.log(id);
      await axios
        .patch(`${baseUrl}/registration/` + id, editedProfile, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then(() => {
          // console.log("Data successfully edited");
          toast("Your data has been successfully updated.");
          invokeModal(false);
        })
        .catch((error: any) => {
          console.log("Could not successfully edit user data");
          console.log(error.message);
        });
    }
  };

  const todownload = async (id: string) => {
    navigate("/downloadcertificate/" + id);
  };

  const makePayment = async (CourseName: string) => {
    await axios
      .get(`${baseUrl}/courses`, {
        headers: { Authorization: `Bearer ${idToken}` },
      })
      .then((responseprofile) => {
        var Courses = responseprofile?.data;
        for (const [courseKey, courseValue] of Object.entries(Courses)) {
          var coursesData: any;
          coursesData = courseKey;
          coursesData = courseValue;
          if (coursesData?.CourseName === CourseName) {
            const slug = coursesData?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
            navigate("/enroll/" + slug);
          }
        }
      });
  };

  return (
    <div>
      <ReferralPage
        isOpen={onOpen}
        onClose={isClose}
        User={user}
        Referrer={Referrer}
      />

      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>

      <Modal show={isShow}>
        <Modal.Header closeButton onClick={close}>
          <Modal.Title className="text-center" style={{ color: "#509b35" }}>
            Update your Profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <form>
              <div className="form-group" style={{ marginBottom: "10px" }}>
                <label>Profile Image</label>
                <input
                  className="form-control is-valid"
                  id="ProfileImage"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleImageUpload}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "10px" }}>
                <label>First Name</label>
                <input
                  type="text"
                  className="form-control is-valid"
                  id="formGroupExampleInput"
                  placeholder="Your First Name"
                  value={editedFirstName}
                  onChange={(e) => {
                    setEditedFirstname(e.target.value);
                  }}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "10px" }}>
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-control is-valid"
                  id="formGroupExampleInput2"
                  placeholder="Your Last Name"
                  value={editedLastName}
                  onChange={(e) => setEditedLastName(e.target.value)}
                />
              </div>

              <div className="form-group" style={{ marginBottom: "10px" }}>
                <label>Mobile Number</label>
                <div className="textinputspwebinar">
                  <PhoneInput
                    country={"ng"}
                    // inputStyle={{width: "100%"}}
                    value={editedPhoneNumber}
                    onChange={(inputphone) => setEditedPhoneNumber(inputphone)}
                    isValid={(value, country: any) => {
                      /* eslint-disable no-useless-escape */
                      if (value.match(/^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/)) {
                        return "Invalid value: " + value + ", " + country.name;
                        /* eslint-disable no-useless-escape */
                      } else if (
                        value.match(/^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/)
                      ) {
                        return false;
                      } else {
                        return true;
                      }
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => {
              UpdateUserProfile(user?.id || "");
            }}
          >
            Save
          </Button>
          <Button variant="danger" onClick={close}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {ready ? (
        <>
          <Header />
          <ToastContainer autoClose={2000} />
          <div className="container profiletoppos">
            <div>
              <h3>Profile</h3>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div>
                  {/* <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}> */}
                  <div className="card" style={{ padding: "40px" }}>
                    <div
                      className="text-center"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      {showProfileImage ? (
                        <>
                          <img
                            src={ProfileImage}
                            alt="profileimage"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "100px",
                              border: "2px solid green",
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            src="../../images/Avatarimage.jfif"
                            alt="avatar"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "100px",
                            }}
                          />
                        </>
                      )}

                      <h4 style={{ marginTop: "15px" }}>
                        {user?.firstname + " " + user?.lastname}
                      </h4>
                    </div>
                    <hr />
                    <div>
                      <h4 style={{ color: "#79797D" }}>Email Address</h4>
                      <p>{user?.email} </p>
                    </div>

                    <hr />

                    <div>
                      <h4 style={{ color: "#79797D" }}>Mobile Number</h4>
                      <p>
                        +<span>{user?.phone}</span>{" "}
                      </p>
                    </div>

                    <hr />
                    <div>
                      <h4 style={{ color: "#79797D" }}>Referral link</h4>
                      <p
                        className="flash"
                        onClick={() => {
                          isOpen();
                        }}
                        style={{ cursor: "pointer", color: "#156614" }}
                      >
                        Click to invite friends{" "}
                      </p>
                    </div>

                    <button className="btn btn-success" onClick={initModal}>
                      Edit your profile
                    </button>
                    <br />
                    <br />
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="topprofile">
                  <div className="card" style={{ padding: "40px" }}>
                    <div className="row">
                      <div className="col-4">
                        <h5
                          className={
                            showCoursesandServices
                              ? "profiletabs"
                              : "notactivepp"
                          }
                          onClick={CoursesandServices}
                        >
                          Courses & Services
                        </h5>
                      </div>
                      <div className="col-4">
                        <h5
                          className={
                            showPayments ? "profiletabs" : "notactivepp"
                          }
                          onClick={Payments}
                        >
                          Payment History
                        </h5>
                      </div>
                      <div className="col-4">
                        <h5
                          className={
                            showCertificates ? "profiletabs" : "notactivepp"
                          }
                          onClick={Certificates}
                        >
                          Certificates
                        </h5>
                      </div>
                    </div>

                    {showPayments ? (
                      <>
                        <hr />
                        <Row>
                          {EnrolledUser.map((item: ICourseRegistration) => {
                            let enrollmentDate;
                            if (
                              item?.createdAt?._seconds !== undefined &&
                              item?.createdAt?._nanoseconds !== undefined
                            ) {
                              enrollmentDate = new Date(
                                item.createdAt._seconds * 1000 +
                                  item.createdAt._nanoseconds / 1000000
                              ).toDateString();
                            } else {
                              enrollmentDate = new Date(item?.createdAt);
                            }
                            return (
                              <div key={item?.id} className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <h4 style={{ color: "#79797D" }}>
                                      {item?.course}
                                    </h4>
                                    <p
                                      style={{
                                        cursor: "pointer",
                                        color: "#156614",
                                      }}
                                    >
                                      {"Enrolment Date: " + enrollmentDate}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    <label style={{ color: "#79797D" }}>
                                      {"Course Price: " +
                                        item?.paymentCurrency +
                                        priceSplitter(item?.coursePrice)}
                                    </label>
                                    <label style={{ color: "#79797D" }}>
                                      {"Paid Price: " +
                                        item?.paymentCurrency +
                                        priceSplitter(item?.paidPrice)}
                                    </label>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          })}
                        </Row>
                        {emptyData ? (
                          <div className="text-center">
                            <h4>
                              ☹️ You are not enrolled for any of our services.
                              Please visit the schools and services to begin
                              your exciting tech journey.
                            </h4>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {showCoursesandServices ? (
                      <>
                        <hr />
                        <Row>
                          {EnrolledUser.length > 0 && (
                            <h2 className="text-center">Courses Enrolled</h2>
                          )}
                          {EnrolledUser.map((item: ICourseRegistration) => {
                            let cohortDate;
                            if (
                              item?.createdAt?._seconds !== undefined &&
                              item?.createdAt?._nanoseconds !== undefined
                            ) {
                              cohortDate = new Date(
                                item.createdAt._seconds * 1000 +
                                  item.createdAt._nanoseconds / 1000000
                              );
                            } else {
                              cohortDate = new Date(item?.createdAt);
                            }
                            let FLASHMESSAGE = false;
                            let LABELVALUE = "";
                            let USERSTATUS = "Enrolled😎";
                            let INDEBT = false;
                            if (
                              item?.HasDeadline ||
                              item?.status === "Partial-payment"
                            ) {
                              INDEBT = true;

                              const addDays = (date: any, days: number) => {
                                let result = new Date(date);
                                result.setDate(result.getDate() + days);
                                return result;
                              };

                              let futureDate = addDays(
                                cohortDate,
                                item?.DeadlineValue
                              );
                              let today = new Date();
                              const calculateDaysLeft = (
                                startDate: any,
                                endDate: any
                              ) => {
                                const oneDay = 24 * 60 * 60 * 1000;
                                return Math.round(
                                  (endDate - startDate) / oneDay
                                );
                              };

                              let daysLeft = calculateDaysLeft(
                                today,
                                futureDate
                              );
                              if (daysLeft < 1) {
                                FLASHMESSAGE = true;
                                LABELVALUE = `Deadline Over. Make payment now.`;
                                USERSTATUS = "Continue to Payment";
                              } else {
                                const inWeeks = Math.floor(daysLeft / 7);
                                const inDays = Math.floor(daysLeft % 7);
                                let moreThanAWeek =
                                  daysLeft < 7 ? " " : ` ${inWeeks} weeks and `;
                                if (daysLeft < 14) {
                                  FLASHMESSAGE = true;
                                }
                                if (daysLeft % 7 === 0) {
                                  LABELVALUE = `Only ${inWeeks} weeks until deadline`;
                                  USERSTATUS = "Continue to payment";
                                } else {
                                  LABELVALUE = `Only${moreThanAWeek}${inDays} days until deadline`;
                                  USERSTATUS = "Continue to payment";
                                }
                              }
                            }
                            return (
                              <div key={item?.id} className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <h4 style={{ color: "#79797D" }}>
                                      {item?.course}
                                    </h4>
                                    <p
                                      style={{
                                        cursor: "pointer",
                                        color: "#156614",
                                      }}
                                    >
                                      {fetchCourseCohortValue(item?.course)}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    {INDEBT ? (
                                      <>
                                        <label
                                          className={
                                            FLASHMESSAGE
                                              ? "flashing-red-label"
                                              : "red-label"
                                          }
                                        >
                                          {LABELVALUE}
                                        </label>
                                        <button
                                          className="btn btn-success"
                                          onClick={() =>
                                            makePayment(item?.course)
                                          }
                                        >
                                          {USERSTATUS}
                                        </button>
                                      </>
                                    ) : (
                                      <div className="btn btn-success">
                                        {USERSTATUS}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          })}

                          {doyenAccess.length > 0 && (
                            <h2 className="text-center">Doyen Access</h2>
                          )}
                          {doyenAccess.map((item) => {
                            let enrollmentDate;
                            if (
                              item?.createdAt?._seconds !== undefined &&
                              item?.createdAt?._nanoseconds !== undefined
                            ) {
                              enrollmentDate = new Date(
                                item.createdAt._seconds * 1000 +
                                  item.createdAt._nanoseconds / 1000000
                              ).toDateString();
                            } else {
                              enrollmentDate = new Date(item?.createdAt);
                            }
                            return (
                              <div key={item?.id} className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <h4 style={{ color: "#79797D" }}>
                                      {item?.product}
                                    </h4>
                                    <p
                                      style={{
                                        cursor: "pointer",
                                        color: "#156614",
                                      }}
                                    >
                                      {"Enrolment Date: " + enrollmentDate}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    <label style={{ color: "#79797D" }}>
                                      {"Package Amount: " +
                                        item?.paymentCurrency +
                                        priceSplitter(item?.price)}
                                    </label>
                                    <label style={{ color: "#79797D" }}>
                                      {"Paid Amount: " +
                                        item?.paymentCurrency +
                                        priceSplitter(item?.price)}
                                    </label>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          })}

                          {handsOnEx.length > 0 && (
                            <h2 className="text-center">Hands On Experience</h2>
                          )}
                          {handsOnEx.map((item) => {
                            return (
                              <div key={item?.id} className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <h4 style={{ color: "#79797D" }}>
                                      {item?.Careerpath}
                                    </h4>
                                    <p
                                      style={{
                                        cursor: "pointer",
                                        color: "#156614",
                                      }}
                                    >
                                      {"Status: " + item?.Status}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    <label style={{ color: "#79797D" }}>
                                      {"Paid Amount: " +
                                        item?.paymentCurrency +
                                        priceSplitter(item?.Price)}
                                    </label>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          })}
                        </Row>
                        {emptyData ? (
                          <div className="text-center">
                            <h4>
                              ☹️ You are not enrolled for any of our services.
                              Please visit the schools and services to begin
                              your exciting tech journey.
                            </h4>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {showCertificates ? (
                      <>
                        <hr />
                        <Row>
                          {UserCertificates.map((item: ICertificate) => (
                            <div
                              key={item.id}
                              className="col-12"
                              style={{ position: "relative" }}
                            >
                              <div className="row">
                                <div className="col-7">
                                  <div>
                                    <h4
                                      style={{
                                        cursor: "pointer",
                                        color: "#156614",
                                      }}
                                    >
                                      {item?.coursename}
                                    </h4>
                                  </div>
                                </div>
                                <div className="col-5">
                                  <div
                                    className="row"
                                    style={{ paddingTop: "2%" }}
                                  >
                                    <div className="col">
                                      {/* <h5 style={{color: "#156614", cursor: "pointer"}} onClick={() => {todownload(item.CourseName)}}>Download</h5> */}
                                    </div>
                                    <div className="col">
                                      <img
                                        className="w-25"
                                        src="../../images/share-2.png"
                                        alt="share"
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          todownload(item?.id);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <hr />
                            </div>
                          ))}
                        </Row>
                        {noCertificates ? (
                          <div className="text-center">
                            <h4>Complete a course to acquire a certificate.</h4>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    <br />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
            <br />
          </div>
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Profilepage;
